import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ProjektArtsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ProjektArtsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ProjektArtsServiceModule {}
